//TODO: If we don't use this dto anywhere remove the whole lib
export class PriceLevelDto {
  public id: number;
  public name: string;

  constructor(id?: number, name?: string) {
    this.id = id;
    this.name = name;
  }
}
